import { gql } from '@apollo/client'

const FOOD_MOOD_QUERY = gql`
  query foodMood($id: ID!) {
    foodMood(id: $id) {
      id
      name
      description
      position
      updatedAt
      updatedBy {
        id
        name
      }
      dishTypes {
        id
      }
      imageUrl
      maxPosition

      synonyms
      isExcludedFromSearch
      isExcludedFromBrowsing
    }
  }
`

export default FOOD_MOOD_QUERY
